import { useMutation } from "react-query";

import axios from "axios";

import { fileServiceEndpoint } from "api/files";

import { calculateSHA256Checksum } from "../../../utils";
import { FilesType } from "../context";

export interface IUploadFileParams {
  filesType: FilesType;
  fileChunk: Blob;
  filename: string;
  chunkIndex: number;
  totalFileSize: number;
}

export async function uploadFile(upload: IUploadFileParams) {
  const formData = new FormData();
  formData.append("chunk", upload.fileChunk);
  formData.append("filename", upload.filename);
  formData.append("chunkIndex", upload.chunkIndex.toString());
  formData.append("totalFileSize", upload.totalFileSize.toString());

  // Calculate checksum for the chunk
  try {
    const checksum = await calculateSHA256Checksum(upload.fileChunk);
    formData.append("checksum", checksum);

    return await axios.post(
      `${fileServiceEndpoint}/files/${upload.filesType}/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Checksum": checksum
        }
      }
    );
  } catch (error) {
    if (error.message.includes("File too large for checksum calculation")) {
      // eslint-disable-next-line no-console
      console.warn("Uploading chunk without checksum due to size:", error.message);
      // Upload without checksum for oversized chunks
      return await axios.post(
        `${fileServiceEndpoint}/files/${upload.filesType}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
    }
    throw error; // Re-throw other errors
  }
}

export const useUploadFileMutation = () => {
  return useMutation({
    mutationFn: uploadFile,
    retry: false
  });
};
